import {type NativeProps} from './ScrollForwarderViewNativeComponent'

export function ScrollForwarderView({children}: NativeProps) {
  return children
}
